module.exports = __webpack_public_path__ + "static/media/car-bread.6a01930d.png";